import { actionType } from "../actions/IleggelseKommentarerAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const ileggelseKommentarReducer = (state = {}, action) =>
  CreateNewReducer(state, action, actionType);

export default ileggelseKommentarReducer;
